import { createContext, useContext, ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { GET_USER } from "../api/graphql/users";
import { User } from '../types/User';

interface UserContextType {
  user: User | null;
  /** True until the first answer for the signed-in user arrives. */
  loading: boolean;
  /** The query runs before sign-in too, so the login page asks again. */
  refetch: () => Promise<void>;
}

const UserContext = createContext<UserContextType>({
  user: null,
  loading: false,
  refetch: async () => {},
});

interface Props {
  children: ReactNode;
}

export const UserProvider = ({ children }: Props) => {
  const { data, loading, refetch } = useQuery<{ user: User }>(GET_USER);

  const user = data?.user || null;

  return (
    <UserContext.Provider
      value={{
        user,
        loading,
        refetch: () =>
          refetch().then(
            () => undefined,
            () => undefined,
          ),
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
